module.exports = __webpack_public_path__ + "static/12-img-1-490224e85b0877c48f42408034c41336.png";